import { PostSearchRequestSectionWeb } from '@nucleus/types/web/sections/post-search-request';
import { useSection } from '@nucleus/web-theme';
import { nucleusClass } from '@nucleus/web-theme-elements';
import classNames from 'classnames';
import React from 'react';
import { BlockLayout } from '../../blockLayouts/Base';
import { BlockPostSearchRequest, BlockPostSearchRequestFallback } from '../../blocks/BlockPostSearchRequest';
import { PostSearchUrlController } from '../../controllers/PostSearchUrlController';
import { getSectionClasses } from '../../lib/classes';
import { Section } from '../../sectionLayouts/Section';
import { SectionLayout } from '../../sectionLayouts/SectionLayout';

export const PostSearchRequestSection = (): JSX.Element => {
  const section = useSection<PostSearchRequestSectionWeb>();

  return (
    <Section className={classNames(nucleusClass('section-search-request'), getSectionClasses(section))}>
      <SectionLayout {...section.payload}>
        <BlockLayout {...section.payload}>
          <React.Suspense
            fallback={<BlockPostSearchRequestFallback {...section.payload} block={section.payload.blocks[0]} />}
          >
            <PostSearchUrlController {...section.payload} engineId={section.payload.blocks[0]?.engineId ?? ''}>
              <BlockPostSearchRequest {...section.payload} block={section.payload.blocks[0]} />
            </PostSearchUrlController>
          </React.Suspense>
        </BlockLayout>
      </SectionLayout>
    </Section>
  );
};
